export {useLocalizedStringFormatter} from 'react-aria/useLocalizedStringFormatter';
